import React, { useEffect, useRef, useState } from 'react'
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../../../cvp-webgames-core/pre-caching/pre-cache-item';
import { AnimationState } from '../../../../cvp-webgames-core/UI/Animation/animation-base';
import { AnimationPage } from '../../../../cvp-webgames-core/UI/Animation/animation-page';
import { constants } from '../../../../misc/constants';
import { BaseConfig } from '../../../BaseConfig';
import PopUp1 from '../../../general/pop-up1';

import "./settings-window.css"
import { CustomGameDataManager, setFocus, setLast508WindowId, TextHtmlTagType } from '../../../../misc/tools';
import Tools from '../../../../cvp-webgames-core/Misc/Tools';
import { MainMenuWindow508Type } from '../../../../pages/MainMenuPage';
import { GameScenarioWindow508Type, set508Window } from '../../../../scenarios/GameBaseScenario';
import AlertUI from '../../../ui/alert-ui';

class SettingsWindowCaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'accessibility-disabled',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/hud/accessibility-enabled.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'download',
				src: process.env.PUBLIC_URL + '/assets/images/download.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'return1',
				src: process.env.PUBLIC_URL + '/assets/images/return1.svg'
			}
		];
	}
}

export const settingsWindowCaching = new SettingsWindowCaching();

const SettingsWindow = (props: SettingsWindowConfig) => {
	const root = useRef(null);

	const [focusSet, setFocusSet] = useState(false);
	const [showPreloadAssetNotNeededAlert, setShowPreloadAssetNotNeededAlert] = useState(false);
	if (!focusSet) {
		Tools.getSaveData().then((retrievedData: CustomGameDataManager) => {
			if (retrievedData.data.isAnimationsEnabled) {
				setTimeout(() => {
					setFocus('settings-window-top');
				}, 1000);
			} else {
				setFocus('settings-window-top', null, 50);
			}

			setFocusSet(true);
		})
	}
	useEffect(() => {
		props.animation.updateProps({
			page: root.current
		});
	}, [root])
	return (
		<div style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			{showPreloadAssetNotNeededAlert ? (
				<AlertUI parameters={{
					htmlContent: `<p>There is no need to preload assets on an iOS device as all of the required data is already in the app.</p>`,
					okButton: {
						onClick: () => {
							set508Window(GameScenarioWindow508Type.Main);
							setShowPreloadAssetNotNeededAlert(false);
						},
						title: 'OK'
					},
					title: 'No Pre-Load Required'
				}}></AlertUI>
			) : (null)}
			<div ref={root} className={"modal-disable-select center-element settings-window-container " + props.animation.getInitialClass()} style={{
				position: 'relative'
			}}>
				<PopUp1
					title={constants.projectTitle}
					buttons={[
						{
							imgSrc: settingsWindowCaching.getItemByKey('accessibility-disabled').src,
							idFor508: 'settings-window-top',
							width: '80%',
							height: '80px',
							buttonText: "Accessibility",
							hoverColor: '#bfddff',
							bgColor: undefined,
							onClick: () => {
								setLast508WindowId('settings-window-top');
								props.onAccessibilityClicked()
							}
						},
						{
							imgSrc: settingsWindowCaching.getItemByKey('download').src,
							width: '80%',
							height: '80px',
							buttonText: "Pre-Load Assets",
							hoverColor: '#bfddff',
							bgColor: undefined,
							onClick: () => {
								if(Tools.isios()) {
									setShowPreloadAssetNotNeededAlert(true);
								} else {
									setLast508WindowId('settings-window-top');
									props.onPreloadClicked()
								}
							}
						},
						{
							imgSrc: settingsWindowCaching.getItemByKey('return1').src,
							width: '80%',
							height: '80px',
							buttonText: "Return to Main Menu",
							hoverColor: '#bfddff',
							bgColor: undefined,
							onClick: props.onReturnToMainMenu
						}
					]}
					onRenderContent={() => {
						return (
							<div className='center-element-horizontal white-text' style={{
								textAlign: 'center',
								width: '100%'
							}}>
								<h1 className=' white-text'>Settings</h1>
								<br />
								<h2>Please select an option:</h2>
							</div>
						)
					}}></PopUp1>
			</div>
		</div>
		
	);

};

export interface SettingsWindowConfig extends BaseConfig {
	animation: AnimationPage;
	onAccessibilityClicked: () => void;
	onPreloadClicked: () => void;
	onReturnToMainMenu: () => void;
}

export default SettingsWindow;